export const getIconName = (name) => {
    const nameLow = name.toLowerCase();
    let iconName = 'icon__layout_';
    if (nameLow.includes('framed')) {
        iconName += nameLow.replace('framed', 'framed-print');
    }
    else if (nameLow.includes('floating')) {
        iconName += nameLow.replace('floating', 'framed-canvas');
    }
    else if (nameLow.includes('poster')) {
        iconName += nameLow.replace('poster', 'poster-print');
    }
    else {
        iconName += nameLow;
    }
    return iconName.replace(/ /g, '-');
};
